<template>
    <div class="homepage">
      
    </div>
</template>

<script>
export default {
  data () {
    return {
      wpData: wpData,
      background_link: '',
      menu_link: '',
      logo_link: '',
      close_link: '',
      slider_images: [],
    }
  },
  mounted() {
    this.background_link = this.wpData.template_directory_uri + "/spa/assets/images/PCG_Holiday20.mp4";
    this.menu_link = this.wpData.template_directory_uri + "/spa/assets/images/menuicon.png";
    this.close_link = this.wpData.template_directory_uri + "/spa/assets/images/closeIcon.png";
    this.logo_link = this.wpData.template_directory_uri + "/spa/assets/images/logo.png";
    this.slider_images = [ 
      { "id":0, "url": this.wpData.template_directory_uri + "/spa/assets/images/portrait1BW.png" }, {"id":1, "url": this.wpData.template_directory_uri + "/spa/assets/images/portrait2BW.png"},{"id":2, "url": this.wpData.template_directory_uri + "/spa/assets/images/portrait3BW.png"}];
    let router = this.$router;
    $(".btn-introteam").click(function(){
      setTimeout(function(){router.push('/team');}, 800);
    })
  },
  methods: {
      gotoMenuPage: function(event){
          alert("Event1");
      }
  }
}
</script>

<style>
.homepage{
    position: relative;
    width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/AppHomePage.vue